module.exports = __webpack_public_path__ + "static/img/75.67bfcd4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/75.jpg
// module id = XM71
// module chunks = 0